import EmailField from 'components/EmailField';
import { localizable } from 'components/Localization';
import NotificationPreview from 'components/NotificationPreview';
import { FooterContainer } from 'components/PanelFooter';
import { observer, Observer } from 'mobx-react';
import {
  DefaultButton,
  PrimaryButton,
} from 'office-ui-fabric-react/lib/Button';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import React, { Component, Fragment } from 'react';

const defaultData = {
  email: '',
  phoneNumber: '',
  salutation: 'mr',
  title: '',
  firstName: '',
  lastName: '',
};

@localizable
@observer
export default class SellerInviteSection extends Component {
  componentDidMount() {
    const { seller } = this.props;
    seller.setData(defaultData);
  }

  handleInvite = () => {
    const { seller } = this.props;
    seller.invite();
  };

  handleBlock = () => {
    const { seller } = this.props;
    seller.block();
  };

  handleCancel = async () => {
    const { seller } = this.props;
    seller.close();
  };

  handleChanged = (field) => (value, _, customValue) => {
    const { seller } = this.props;
    seller.propChanged(field, value, customValue);
  };

  handleTitleChanged = (option, _, value) => {
    const { seller } = this.props;
    seller.titleChanged(option, value);
  };

  render() {
    const { sale, seller, t } = this.props;

    const config = sale.saleConfig;

    return (
      <Fragment>
        <Panel
          headerText={t('Invite Seller')}
          type={PanelType.medium}
          onDismiss={this.handleCancel}
          isOpen={true}
          isFooterAtBottom={true}
          closeButtonAriaLabel="Close"
          onRenderFooterContent={() => {
            return (
              <FooterContainer>
                <DefaultButton text={t('Block')} onClick={this.handleBlock} />
                <PrimaryButton text={t('Invite')} onClick={this.handleInvite} />
                <Observer
                  render={() => (
                    <NotificationPreview
                      action={`/api/v1/sellers/invite/notifications`}
                      trigger="button"
                      query={{
                        locale: this.props.intl.locale,
                      }}
                      data={{
                        saleId: sale.saleId,
                        data: seller.data,
                      }}
                    />
                  )}
                />
                <DefaultButton text={t('Cancel')} onClick={this.handleCancel} />
              </FooterContainer>
            );
          }}
        >
          <div className="ms-Grid">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-lg6 ms-md12 ms-sm12">
                <EmailField
                  label={t('Email')}
                  value={seller.data.email}
                  iconProps={{ iconName: 'Mail' }}
                  required={true}
                  onChanged={this.handleChanged('email')}
                  validateOnLoad={false}
                  autoComplete="nope"
                  validateOnFocusOut
                />
              </div>
              <div className="ms-Grid-col ms-lg6 ms-md12 ms-sm12">
                <TextField
                  label={t('Phone number')}
                  placeholder="+49 150 0000 0000"
                  value={seller.data.phoneNumber}
                  iconProps={{ iconName: 'Phone' }}
                  onChanged={this.handleChanged('phoneNumber')}
                  validateOnLoad={false}
                  errorMessage={
                    seller.phoneNumberError === ''
                      ? seller.phoneNumberError
                      : t(seller.phoneNumberError)
                  }
                  validateOnFocusIn={true}
                  validateOnFocusOut={true}
                  autoComplete="nope"
                  inputMode="tel"
                />
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-md12 ms-sm12 ms-lg6">
                <ComboBox
                  label={t('Salutation')}
                  name="salutation"
                  required={true}
                  allowFreeform={false}
                  autoComplete="nope"
                  onChanged={this.handleChanged('salutation')}
                  value={
                    seller.data.salutation
                      ? t(`salutation::${seller.data.salutation}`)
                      : ''
                  }
                  options={config.salutationTypes.map((key) => {
                    return { key: key, text: t(`salutation::${key}`) };
                  })}
                />
              </div>
              <div className="ms-Grid-col ms-md12 ms-sm12 ms-lg6">
                <ComboBox
                  label={t('Title')}
                  name="title"
                  allowFreeform={true}
                  autoComplete="nope"
                  onChanged={this.handleTitleChanged}
                  value={
                    seller.data.title ? t(`title::${seller.data.title}`) : ''
                  }
                  options={[{ key: '', text: '' }].concat(
                    config.titleTypes.map((key) => {
                      return { key: key, text: t(`title::${key}`) };
                    })
                  )}
                />
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-md12 ms-sm12 ms-lg6">
                <TextField
                  label={t('First name')}
                  value={seller.data.firstName}
                  onChanged={this.handleChanged('firstName')}
                  required={true}
                  validateOnLoad={false}
                  onGetErrorMessage={this.requiredValidation}
                  validateOnFocusOut
                  autoComplete="nope"
                />
              </div>
              <div className="ms-Grid-col ms-md12 ms-sm12 ms-lg6">
                <TextField
                  label={t('Last name')}
                  value={seller.data.lastName}
                  onChanged={this.handleChanged('lastName')}
                  required={true}
                  validateOnLoad={false}
                  onGetErrorMessage={this.requiredValidation}
                  validateOnFocusOut
                  autoComplete="nope"
                />
              </div>
            </div>

            {config.localeCodes.length > 1 && (
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-lg12 ms-md12 ms-sm12">
                  <Dropdown
                    label={t('Locale')}
                    selectedKey={seller.data.locale}
                    onChanged={this.handleChanged('locale')}
                    options={config.localeCodes.map((key) => {
                      return { key: key, text: t(`locale::${key}`) };
                    })}
                  />
                </div>
              </div>
            )}

            {seller.isBlocked && (
              <div
                className="ms-Grid-row"
                style={{ color: 'rgb(168, 0, 0)', marginTop: '15px' }}
              >
                <div className="ms-Grid-col ms-md12 ms-sm12 ms-lg6">
                  {t('Blocked')}
                </div>
              </div>
            )}
          </div>
        </Panel>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/SellerInviteSection/SellerInviteSection.jsx